var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-center button-container"},[(_vm.isPlaying)?_c('span',{staticClass:"player-button pause-button d-inline-block",on:{"click":_vm.listen}}):_c('span',{staticClass:"player-button play-button d-inline-block",on:{"click":_vm.listen}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a13796b2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PlayerButtonSmall/PlayerButtonSmallWithoutLabel.vue
// module id = null
// module chunks = 